import { IconDefinition, faCircleInfo } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import parse from "html-react-parser";
import LightTooltip from "../../../components/LightTooltip";
import ListaPermissao from "../../../interfaces/entities/Permissoes/ListaPermissao";
import TipoPermissao from "../../../interfaces/entities/Permissoes/TipoPermissao";
import { sxBoxNotificationsPermissionsForm, sxFormControlLabel, sxFormTitle, sxTooltipCheckFormLabel } from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { useId } from "react";

const NotificationsPermissionForm: React.FC<{
  formData?: TipoPermissao;
  formTitle: string;
  onPermissionChange: (permissao: ListaPermissao) => void
}> = ({ formTitle, formData, onPermissionChange }) => {

  const uniqueId = useId();

  const { textStyleAccessibility, contrastColorAccessibility, contrastMode } = useAccessibility();

  const handleCheck = (permissao: ListaPermissao) => {
    onPermissionChange(permissao);
  };

  return (
    <Box>
      <div>
        <Typography style={textStyleAccessibility} sx={sxFormTitle}>{formTitle}</Typography>
      </div>
      <label id={`${uniqueId}-label`} htmlFor={uniqueId} aria-label={`${formTitle} ${formData?.listaPermissao.length} itens.`} />
      <Box 
        sx={sxBoxNotificationsPermissionsForm}
        role="group" 
        id={uniqueId}
        aria-labelledby={`${uniqueId}-label`}
      >
        {formData?.listaPermissao.map((permissao, index) => (
          <div style={{display: 'flex', alignItems: 'center'}}>
          <FormControlLabel
            sx={sxFormControlLabel}
            key={permissao.idPermissao}
            value={permissao.valor}
            aria-label={`item ${index + 1} de ${formData?.listaPermissao.length}: ${permissao.descr}`}
            control={
              <Checkbox
                onChange={() => handleCheck(permissao)}
                style={contrastColorAccessibility}
                checked={permissao.valor}
              />}
            label={
              <Box sx={sxTooltipCheckFormLabel} style={textStyleAccessibility}>
                {permissao.descr}
              </Box>
            }
          />
          <LightTooltip
            title={parse(permissao.txtAjuda)}
            placement="right"
          >
            <FontAwesomeIcon icon={faCircleInfo as IconDefinition} className={`${contrastMode ? 'fa-icon18x18-accessibility' : 'fa-icon18x18'}`} />
          </LightTooltip>
          </div>
        ))}
      </Box>
    </Box>
  )
}

export default NotificationsPermissionForm;